/// <reference path="../../_references.ts" />
module onvio.setup.list {
    'use strict';

    export interface ILateFeeTemplateDomainModel extends bmp.IDomainModel, cs.ILateFeeTemplateV1Dto {
        $hasMaximumCharge: boolean;
    }

    // /* i18nextract */'Bluemoon.Setup.LateFeeTemplate.MinimumChargeGreaterError'
    // /* i18nextract */'Bluemoon.Setup.LateFeeTemplate.MaximumChargeLessError'
    export class LateFeeTemplateDomainModel implements bmp.IDomainModel {
        public hasMaximumCharge: boolean;

        static $inject = [
            '$injector',
            '$translate',
            'fef.Utils',
            'bmpProviderUtils',
            'bmpBigNumberUtils'];

        constructor(
            private $injector: ng.auto.IInjectorService,
            private $translate: ng.translate.ITranslateService,
            private utils: fef.IUtilsService,
            private providerUtils: bmp.IProviderUtilsService,
            private bigNumberUtils: bmp.globalize.IBigNumberUtils) {
        }

        initializeModel(contextId: cs.INamedReferenceDto, model: cs.ILateFeeTemplateV1Dto,
            defaultModel: cs.ILateFeeTemplateV1Dto): void {
            Object.defineProperty(
                model,
                '$hasMaximumCharge',
                {
                    get: () => {
                        return this.hasMaximumCharge;
                    },
                    set: (value: any) => {
                        this.hasMaximumCharge = value;
                        if (value) {
                            model.maximumCharge = '0';
                        } else {
                            model.maximumCharge = null;
                        }
                    }
                });
                Object.defineProperty(
                    model,
                    '$scaledAnnualRate',
                    {
                        get: () => {
                            var rate = this.bigNumberUtils.safeParseBigNumber(model.annualRate);
                            if (rate) { return rate.times(100).toString(); }
                            return model.annualRate;
                        },
                        set: (value: any) => {
                            var rate = this.bigNumberUtils.safeParseBigNumber(value);
                            if (rate) {
                                model.annualRate = rate.div(100).toString();
                            } else { model.annualRate = value; }
                        }
                    });
            this.hasMaximumCharge = this.utils.exists(model.maximumCharge);
        }

        finalizeModel(contextId: cs.INamedReferenceDto, model: cs.ILateFeeTemplateV1Dto,
            defaultModel: cs.ILateFeeTemplateV1Dto): void {
            //This block is empty
        }

        checkMaximumAndMinimumCharge(model: cs.ILateFeeTemplateV1Dto): boolean {
            if (this.utils.exists(model)) {
                var maximumCharge = this.bigNumberUtils.safeParseBigNumber(model.maximumCharge);
                var minimumCharge = this.bigNumberUtils.safeParseBigNumber(model.minimumCharge);
                if (this.utils.exists(maximumCharge) && this.utils.exists(minimumCharge) && maximumCharge.lt(minimumCharge)) {
                    return false;
                } else {
                    return true;
                }
            }
            return true;
        }
    }

    angular.module(
        'onvio.setup.list.LateFeeTemplate',
        [
            'pascalprecht.translate',
            'fef',
            'bmpProviderUtils',
            'bmpBigNumberUtils'
        ]).service('onvio.setup.list.LateFeeTemplate.DomainModel', LateFeeTemplateDomainModel);
}
